import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Sparkles, Download } from 'lucide-react';
import Wave from '@/components/ui/wave';

const WordPressHero = () => {
  const scrollToShowcase = () => {
    document.getElementById('plugin-showcase')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToRequest = () => {
    document.getElementById('custom-request')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-[80vh] bg-black overflow-hidden flex items-center">
      {/* Animated gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/20 via-black to-luxury-900/30 animate-fade-in" />
      
      {/* Animated grid pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(200,168,125,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(200,168,125,0.03)_1px,transparent_1px)] bg-[size:64px_64px]" />
      
      <div className="container mx-auto px-6 relative z-10 py-20">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold/10 text-gold text-sm font-medium mb-6 animate-scale-in">
            <Sparkles className="w-4 h-4" />
            <span>AI-Powered WordPress Solutions</span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight text-white">
            Build or Discover{' '}
            <span className="bg-gradient-to-r from-gold via-primary to-gold bg-clip-text text-transparent">
              AI-Powered
            </span>
            <br />
            WordPress Plugins
          </h1>

          {/* Subtext */}
          <p className="text-lg md:text-xl text-white/80 mb-10 max-w-2xl mx-auto">
            Lovabuild helps you create intelligent, automated, and scalable WordPress plugins with cutting-edge AI agents.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              size="lg"
              onClick={scrollToRequest}
              className="group"
            >
              Request a Custom Plugin
              <Sparkles className="w-4 h-4 ml-2 group-hover:rotate-12 transition-transform" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={scrollToShowcase}
            >
              <Download className="w-4 h-4 mr-2" />
              Browse Plugins
            </Button>
          </div>
        </div>
      </div>

      {/* Wave at the bottom */}
      <div className="absolute bottom-0 left-0 right-0 z-10">
        <Wave color="#c8a87d" height={80} />
      </div>
    </section>
  );
};

export default WordPressHero;
